const {
    main_scroll_area_jump_to
} = require('./main_scroll_area_jump_to.js');


module.exports.activate_section_apply = () => {
    let DOM_section_apply_externsvg;
    DOM_section_apply_externsvg = document.querySelector('extern-svg[data-mountpoint="section_apply"]');

    if(DOM_section_apply_externsvg === null) return;

    let DOM_svg=DOM_section_apply_externsvg;
    DOM_svg.addEventListener('jump_to_participation_fee',()=>{
        main_scroll_area_jump_to("#section_participation_fee");
    });
    DOM_svg.addEventListener('jump_to_requirement',()=>{
        main_scroll_area_jump_to("#section_requirement");
    });
    DOM_svg.addEventListener('jump_to_program',()=>{
        main_scroll_area_jump_to("#section_program");
    });

}
